import THUMB_GEMX from '@/modules/ab-testing/assets/svg/provider-source/gemx.svg';

export const THUMBNAIL = {
  THUMB_GEMX,
};
